import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import * as CrudServices from "../../../../../service/crudServices";
import { Checkbox, Input } from "antd";
import { IconSearch } from "../../../../../asset";
import { setGlobalDeliveryType } from "../../../../../store/reducer/globalMultipleSearchSelect.reducer";

const MSSDeliveryType = ({
  setValueMSS,
  valueMSS,
  children,
  togglerClassName,
  placeholder,
  className,
  ...attrs
}) => {
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const btnDropdownRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [listData, setListData] = useState([]);
  const [listSelected, setListSelected] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [totalData, setTotalData] = useState(null);
  const [isSelectedAll, setIsSelectedAll] = useState(false);

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const getTotalData = useCallback(async () => {
    const resInitiate = await CrudServices.getInitiate(
      token,
      `/delivery-type/initiate`,
      {
        page: 1,
        limit: 100,
      }
    );
    if (resInitiate?.ok && resInitiate?.initiate !== null) {
      setTotalData(resInitiate?.initiate?.count_data);
      return;
    }
    setTotalData(null);
  }, [token]);

  useEffect(() => {
    getTotalData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getListDeliveryType = useCallback(
    async (newParams) => {
      const res = await CrudServices.getList(
        token,
        `/delivery-type`,
        newParams
      );

      if (res?.ok && res?.data !== null) {
        const list = res?.data.map((el) => {
          return {
            id: el?.id,
            delivery_type: `${el?.delivery_code} - ${el?.delivery_type}`,
          };
        });

        if (newParams?.filter && newParams?.filter.includes("delivery_type")) {
          setListData([...list]);
          return;
        }
        list.unshift({ id: -1, delivery_type: "Select All" });
        setListData([...list]);
      }
      if (res?.ok && res?.data === null) {
        setListData([{ id: -1, delivery_type: "Select All" }]);
      }
    },
    [token]
  );

  const handleClickSelectData = useCallback(
    (item) => {
      if (item?.id === -1) {
        if (listSelected.length === 0 || !listSelected) {
          setListSelected([-1]);
          dispatch(setGlobalDeliveryType([-1]));
          return;
        }
        if (listSelected.length && listSelected.length - 1 !== totalData) {
          if (listSelected.includes(-1)) {
            setListSelected([]);
            dispatch(setGlobalDeliveryType([]));
            return;
          }
          setListSelected([-1]);
          dispatch(setGlobalDeliveryType([-1]));
          return;
        }
        if (listSelected.length && listSelected.includes(-1)) {
          setListSelected([]);
          dispatch(setGlobalDeliveryType([]));
        }

        return;
      }
      if (item?.id !== -1) {
        if (listSelected.length === 0) {
          const listDataSelected = listSelected;
          listDataSelected.push(item);
          setListSelected([...listDataSelected]);
          dispatch(setGlobalDeliveryType([...listDataSelected]));
          return;
        }
        const isAllSelected = listSelected.includes(-1);

        if (isAllSelected) {
          const idFiltering = [-1];
          idFiltering.push(item?.id);
          const newList = listData.filter(
            (el) => !idFiltering.includes(el?.id)
          );
          setListSelected([...newList]);
          dispatch(setGlobalDeliveryType([...newList]));
          return;
        }
        const isExist = listSelected.some((el) => el?.id === item?.id);
        if (isExist) {
          const listDataFiltered = listSelected.filter(
            (el) => el?.id !== item?.id
          );
          setListSelected([...listDataFiltered]);
          dispatch(setGlobalDeliveryType([...listDataFiltered]));
          return;
        } else {
          const list = listSelected;
          list.unshift(item);
          setListSelected([...list]);
          dispatch(setGlobalDeliveryType([...list]));
          return;
        }
      }
    },
    [dispatch, listData, listSelected, totalData]
  );

  const isCheckedSelectAll = useMemo(() => {
    if (listSelected !== undefined && listSelected.length === totalData) {
      setIsSelectedAll(true);
      return true;
    }
    setIsSelectedAll(false);
    return false;
  }, [listSelected, totalData]);

  const isCheckedPerItem = useCallback(
    (item) => {
      if (listSelected.length > 0) {
        if (listSelected.length === totalData || listSelected.includes(-1)) {
          return true;
        }
        const isExist = listSelected.some((el) => el.id === item.id);
        return isExist;
      }
      return false;
    },
    [listSelected, totalData]
  );

  const isAllDepot = useMemo(() => {
    if (listSelected.length) {
      if (listSelected.includes(-1)) {
        return true;
      }
      const length = listSelected.length;
      if (listSelected.length > 0 && length === totalData) {
        return true;
      }
    }
    return false;
  }, [listSelected, totalData]);

  const onChangeSearch = useCallback((val) => {
    setSearchKeyword(val);
  }, []);

  useEffect(() => {
    if (!searchKeyword) {
      const resetParams = {
        page: 1,
        limit: 100,
      };
      getListDeliveryType(resetParams);
      return;
    }
    const newParams = {
      page: 1,
      limit: 100,
      filter: `delivery_type lk ${searchKeyword}`,
    };
    getListDeliveryType(newParams);
  }, [getListDeliveryType, searchKeyword]);

  return (
    <div
      className={"dropdown-dds".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className="value-mss"
        onClick={togglerDropdownContent}
        ref={btnDropdownRef}
      >
        {isAllDepot ? (
          <span className="list-value-mss">All Delivery Type</span>
        ) : isCheckedSelectAll === false && listSelected.length !== 0 ? (
          listSelected.map((item, index) => (
            <span key={index} className="list-value-mss">
              {item?.delivery_type}
            </span>
          ))
        ) : (
          <span className="placeholder-mss">Select Delivery Type</span>
        )}
      </button>
      <div></div>
      <div
        className={"dropdown-dds-menu".concat(
          isShowDropdownContent ? " active mt-2 pb-10" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="my-2 px-2">
          <Input
            placeholder="Search By Delivery Type"
            size="large"
            suffix={<img src={IconSearch} alt="icon-search" />}
            onChange={(evt) => onChangeSearch(evt.target.value)}
          />
        </div>
        <div className="overflow-auto max-h-[300px]">
          {listData?.map((el, index) => (
            <div
              key={index}
              className={"dropdown-dds-item truncate"}
              onClick={() => handleClickSelectData(el)}
            >
              <div className="w-full flex justify-between px-2">
                <span>{el?.delivery_type}</span>
                <Checkbox checked={isCheckedPerItem(el)} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MSSDeliveryType;
